<template>
<div class="chapter">
<div class="inner_page">
<a id="page_1"></a>
<h1 class="titlea">IMAGES OF WAR</h1>
<h1 class="title">HEYDRICH</h1>
<h1 class="title1">THE BUTCHER OF PRAGUE</h1>
<p class="subtitle">RARE PHOTOGRAPHS FROM WARTIME ARCHIVES</p>
<p class="author">Ian Baxter</p>
<div class="image_containerf">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?600950ba